<script lang="ts">
	import type { LogoSliderBlock as LogoSliderBlockType } from '$models/Block/LogoSliderBlock';
	import type { Snippet } from 'svelte';
	import LogoSliderBlockView from './LogoSliderBlockView.svelte';

	type Logo = LogoSliderBlockType['logos'][number];

	interface Props {
		block: LogoSliderBlockType;
	}

	const { block }: Props = $props();
</script>

{#snippet renderTrack(renderLogo: Snippet<[Logo, number]>)}
	<div class="logo-slider">
		<div class="slider">
			<div class="slider-viewport">
				<div class="slider-container">
					{#each block.logos as logo, index (`${logo.image.url}:${index}`)}
						<div class="slider-item">
							{@render renderLogo(logo, index)}
						</div>
					{/each}
				</div>
			</div>
		</div>
	</div>
{/snippet}

<LogoSliderBlockView {block} {renderTrack} />
